export function getCopyTitle(original) {
  return `Copy of ${original}`;
}
